const styles = {
  tableHeadCollapse: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme => theme.spacing(1.5, 1),
    backgroundColor: theme => theme.palette.neutral.lightest,
    boxShadow: theme => theme.shadows[1],
  },
  tableHeadCollapseIcon: {
    pr: 1,
    '& svg': {
      width: 24,
      height: 24,
    },
  },
  tableHeadCollapseTitle: {
    fontSize: 16,
    color: theme => theme.palette.neutral.main,
    mt: 1,
  },
  tableHeadCollapseButtonIcon: {
    ml: 'auto',
    color: theme => theme.palette.primary.dark,
    '& svg': {
      transition: 'transform 0.3s ease',
      transform: 'rotate(180deg)',
    },
    '&.is-collapsed svg': {
      transform: 'rotate(0deg)',
    },
  },
  tableCollapse: {
    backgroundColor: theme => theme.palette.neutral.white,
  },
  tableCellMenu: {
    '&.MuiTableCell-root.icon': {
      pr: 1,
    },
  },
}

export default styles
